import React, { useContext } from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Formik } from "formik"
import _ from "lodash"

import { getField, getProductField } from "@/onboarding/features/product/selectors"
import { updateFields } from "@/onboarding/features/product/Slice"
import FormikBootstrap from "@/components/formik-bootstrap"
import { ReservedFields } from "@/onboarding/features/product/models/Product"
import TextDisplay from "@/onboarding/features/product/components/shared/TextDisplay"
import EditDetailsAndRates from "@/onboarding/features/product/components/shared/EditDetailsAndRates"
import SubmittingSpinner from "@/onboarding/features/product/components/shared/SubmittingSpinner"
import { SubmittingContext } from "@/onboarding/features/product/helpers"
import SubmitButton from "@/onboarding/features/product/components/shared/buttons/SubmitButton"
import SubmitAndApplyButton from "@/onboarding/features/product/components/shared/buttons/SubmitAndApplyButton"

const Edit = ({ setEditing }): JSX.Element => {
  const { value } = useSelector(getProductField(ReservedFields.HEADSET_COMPONENTS))
  const dispatch = useDispatch()
  const field = useSelector(getField(ReservedFields.HEADSET_FEE_RATESHEET))
  const [submitting, setSubmitting] = useContext(SubmittingContext)

  return (
    <Formik
      enableReinitialize
      initialValues={{
        headsetComponents: value,
        [ReservedFields.HEADSET_FEE_RATESHEET]: field.value,
      }}
      onSubmit={(values) => {
        setSubmitting(true)
        dispatch(
          updateFields({
            values: {
              [ReservedFields.HEADSET_COMPONENTS]: values.headsetComponents,
              [ReservedFields.HEADSET_FEE_RATESHEET]: values[ReservedFields.HEADSET_FEE_RATESHEET],
            },
          })
        )
      }}
    >
      {({ handleSubmit, values }) => (
        <Form onSubmit={handleSubmit}>
          {_.isEmpty(values.headsetComponents) ? (
            <p className="text-muted">
              Once headset components have been loaded, you can edit them here.
            </p>
          ) : (
            <EditDetailsAndRates name={ReservedFields.HEADSET_FEE_RATESHEET}>
              <h5>Edit Details</h5>
              {_(values.headsetComponents)
                .map((headset, index) => _.merge({ index }, headset))
                .groupBy("category")
                .map((headsets, category) => (
                  <Row key={category}>
                    <h3 className="h6">{_.startCase(category)}</h3>
                    <Col>
                      {headsets.map((headset, index) => (
                        <Row key={index} className="mb-4">
                          <Col md={3}>
                            <TextDisplay value={headset.name} />
                          </Col>
                          <Col md={5}>
                            <FormikBootstrap.Switch
                              name={`headsetComponents[${headset.index}].headsetProvided`}
                              label="Headset provided?"
                            />
                          </Col>
                        </Row>
                      ))}
                    </Col>
                  </Row>
                ))
                .value()}
            </EditDetailsAndRates>
          )}
          <div className="d-flex gap-2">
            <SubmitButton />
            <SubmitAndApplyButton />
            <Button
              size="sm"
              variant="outline-danger"
              onClick={() => setEditing(false)}
              disabled={submitting}
            >
              <i className="fas fa-times me-2" />
              Cancel
            </Button>
            <SubmittingSpinner />
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default Edit
